import { bookingInfo } from './bookingInfoInterface';

const ecommerceNames = [
    'add_payment_info',
    'add_to_cart',
    'begin_checkout',
    'purchase',
    'remove_from_cart',
    'select_item',
    'view_item',
    'view_item_list',
    'quotation', // our own custom event for bookings that are not confirmed
];

export function sendTagManagerEvent(eventname: string, eventParams: any, userData: any = {}) {
    return new Promise(function (resolve, reject) {
        const dataLayer = (window as any).dataLayer;
        if (typeof dataLayer === 'object' && typeof dataLayer.push === 'function') {
            // GA4 via Tag Manager
            if (ecommerceNames.includes(eventname)) {
                dataLayer.push({
                    ecommerce: null,
                });
                let dlData = Object.assign(
                    {
                        event: eventname,
                        ecommerce: eventParams,
                        eventCallback: resolve,
                    },
                    userData
                );
                dataLayer.push(dlData);
            } else {
                let params = eventParams;
                params.event = eventname;
                params.eventCallback = resolve;
                dataLayer.push(params);
            }
            setTimeout(() => resolve(''), 5000);
        }
        resolve('');
    });
}

export function createPurchasePayload(info: bookingInfo) {
    return {
        currency: info.currency,
        value: info.transactionValue,
        transaction_id: info.bookingReference,
        coupon: info.coupon || undefined,
        items: info.items.map(item => {
            return {
                item_id: item.itemId,
                item_name: item.itemName,
                price: item.price,
                quantity: item.quantity,
                discount: item.discount || undefined,
                coupon: item.coupon || undefined,
            };
        }),
    };
}

export function createUserDataPayload(info: bookingInfo) {
    if (!info.customerData || Object.keys(info.customerData).length === 0) {
        return {};
    }
    return {
        user_data: info.customerData,
    };
}
